import { createFileRoute } from '@tanstack/react-router'
import EmployeeRequestTickets from '@/features/employee-portal/pages/EmployeeRequestTickets'

export const Route = createFileRoute('/_authenticated/employee-portal/request-tickets')({
  component: EmployeeRequestTickets,
})
